import { useQuery, QueryOptions, QueryResult } from '@eika-infrastruktur/react-query';

import type { AccountId, AccountInterest } from '../generated-types';
import { getInterest } from '../services/accountService';

const useInterests = (
    accountId?: AccountId,
    options: Partial<QueryOptions<AccountInterest>> = {},
): QueryResult<AccountInterest> =>
    useQuery({
        ...options,
        queryKey: ['interest', accountId],
        queryFn: () => getInterest(accountId!),
        enabled: !!accountId,
        staleTime: Infinity,
    });

export default useInterests;
